import { User } from '../models';

export function hasReportsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m === 'reports.view');
}

export function hasAdminPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  return hasAdminUsersPageRole(user) || hasAdminRolesPageRole(user) || hasAdminSystemSettingsPageRole(user);
}

export function hasAdminUsersPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('users.'));
}

export function hasAdminRolesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('roles.'));
}

export function hasAdminSystemSettingsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('systemSettings.'));
}

export function isSuperadmin(user?: User): boolean {
  if (!user || !user.roles) {
    return false;
  }
  return user.roles.some(m => m.name === 'Superadmin');
}

export function hasPermission(user: User | undefined, permission: string): boolean {
  // return false;
  if (!user) return false;
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions?.some(p => p === permission) || false;
}

export function hasAdminNotificationPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('Notifications.'));
}
export function hasAdminErrorStatusPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('errorStatuses.'));
}
export function hasAdminErrorCodesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('errorCodes.'));
}
export function hasAdminErrorFindersPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('errorFinders.'));
}

export function hasAdminCountriesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('countries.'));
}

export function hasAdminFourMsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('fourMs.'));
}

export function hasAdminFrequenciesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('frequencies.'));
}
export function hasAdminCustomerClassesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('customerClasses.'));
}
export function hasAdminEquipmentsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('equipments.'));
}
export function hasAdminProductionSitesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('productionSites.'));
}
export function hasAdminSuppliersPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('suppliers.'));
}

export function hasAdminCostsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('costs.'));
}

export function hasMatricesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m === 'matrices.view');
}

function getPermissions(user?: User): string[] | null {
  if (!user || !user.permissions) {
    return null;
  }
  return user.permissions.map(m => m.key);
}
